exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root {\n  /**\n   * TODO: Import design system variables from global.css\n   */\n}\n", ""]);

// exports
